export const isOverflowing = (element: HTMLElement, threshold = 1) => {
  return element.scrollHeight > element.clientHeight + threshold;
};
